import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { getFileSetting } from "../../reducers/commonReducer";

const schema = yup.object().shape({
  name: yup.string().required(),
  status: yup.string().required(),
  description: yup.string().required(),
  category: yup
    .array()
    .required("Category is required")
    .min(1, "At least one category is required"),
});

function FileSettingAction({
  title,
  popUpTitle,
  id,
  name,
  description,
  status,
  category,
  api,
}) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const { getCategoriesData } = useSelector((state) => state.commonReducer);
  return (
    <>
      <Button className="bg-thememain" onClick={handleShow}>
        {title}
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{popUpTitle}</Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={schema}
          onSubmit={async (values, { resetForm }) => {
            const apiResp = await dispatch(api(values));
            if(apiResp?.payload?.status){
              dispatch(getFileSetting());
              resetForm({ values: "" });
              handleClose();
            }
          }}
          initialValues={{
            id,
            name,
            description,
            status,
            category : category?.map((cat) => cat?.id)
          }}
        >
          {({ handleSubmit, handleChange, setFieldValue,values, errors }) => (
            <Form className="container" onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Col md={12} sm={12}>
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Name"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      isInvalid={!!errors.name}
                    />

                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={12} sm={6}>
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Description"
                      name="description"
                      value={values.description}
                      onChange={handleChange}
                      isInvalid={!!errors.description}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.description}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6} sm={6}>
                  <Form.Label>Category</Form.Label>
                  <Form.Control
                    as="select"
                    multiple={true}
                    onChange={handleChange}
                    name="category"
                    className="form-control bg"
                    value={values.category}
                    isInvalid={!!errors.category}
                  >
                    <option value="">Select Category</option>
                    {
                      !!getCategoriesData && getCategoriesData?.map((cat, index) => <option key={index} value={cat?.id}>{cat?.name}</option>)
                    }
                  </Form.Control>
                </Col>
                <Col md={6} sm={6}>
                  <Form.Label>Status</Form.Label>
                  <Form.Control
                    as="select"
                    onChange={async (e) => {
                      setFieldValue("status", (/true/).test(e.target.value));
                    }}
                    name="status"
                    className="form-control bg"
                    value={values.status}
                    isInvalid={!!errors.status}
                  >
                    <option value="">Select Status</option>
                    <option value={true}>Active</option>
                    <option value={false}>Inactive</option>
                  </Form.Control>
                </Col>
              </Row>
              <Modal.Footer>
                <Button variant="success" type="submit">
                  Submit
                </Button>
                <Button variant="danger" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}

export default FileSettingAction;
